import React from "react"
import { useSelector } from "react-redux"

import Images from "assets/images"
import {
    StoreType,
    SilDeviceNestedType,
} from "client/store"
import { Logo } from "client/components"

import {
    ModelWrapper,
    BlockWrapper,
    Block,
} from "client/pages/sil/modelStyled"

import { getSilDeviceTitle } from "client/pages/sil/formulas"

interface ModelParams {
    nestedDevices: readonly SilDeviceNestedType[]
}

const Model = ({
    nestedDevices,
}: ModelParams) => {
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const lang = useSelector((state: StoreType) => state.system.lang)

    return (
        <ModelWrapper direction="row">
            {
                nestedDevices && nestedDevices.map((nested, index) => nested && (
                    // eslint-disable-next-line react/no-array-index-key
                    <BlockWrapper key={index} type="subsystem">
                        <Block title={getSilDeviceTitle(nested as SilDeviceNestedType, moduleList, lang)}>
                            <Logo
                                size={100}
                                logo={
                                    nested.logo
                                    || (nested.qidProductId ? Images.qidProductLogo : Images.silDeviceLogo)
                                }
                            />
                        </Block>
                    </BlockWrapper>
                ))
            }
        </ModelWrapper>
    )
}
export default Model
